<template>
  <div v-if="visible" class="tip-mask">
    <div class="tip-panel">
      <div class="tip-box">
        <img class="tip-robot" :src="toastMsg" alt="" />
        <p class="tip-text">{{ message }}</p>
      </div>
      <div v-if="showClose" class="tip-close" @click="onClose"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErkeAiStoreTipDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: ''
    },
    // 是否显示关闭按钮
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      toastMsg: require('@/assets/img/erkeAiStore/toastMsg.png')
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    }
  }
}
</script>

<style lang="less" scoped>
.tip-mask {
  position: fixed;
  inset: 0;
  z-index: 2000;
  background: rgba(0, 0, 0, 0.72);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  box-sizing: border-box;
}

.tip-panel {
  width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tip-box {
  width: 100%;
  background: #fff;
  border-radius: 24px;
  padding: 28px 24px 32px;
  box-sizing: border-box;
  text-align: center;
}

.tip-robot {
  display: block;
  width: 89px;
  height: auto;
  margin: 0 auto 4px;
}

.tip-text {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #000;
  line-height: 1.5;
}

.tip-close {
  margin-top: 24px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: url('~@/assets/img/erkeAiStore/close.png') no-repeat center center;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
}
</style>
